
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Message from '@/components/message.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    liveRoomProductRepositorylist,
    liveRoomProductRepositorydelete
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      Message,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private tablelist:any = []
    private tableloading = false
    private rowmsg:any = {}
    private batchShow = false
    private batchmsg:any = {
      num:'',
    }
    private chooselist:any = []

    private delShow = false
    private deltype = 1

    private mounted () {
      this.gettablelist()
    }


    private handleSelectionChange(e){
      this.chooselist = e
      // console.log(this.chooselist)
    }
    private async confirmbatch(){

    }
    private async confirmDelete(){
      this.tableloading = true
      try{
        let data:any = {
          IdList:[]
        }
        if(this.deltype==1){
          data.IdList = [this.rowmsg.Id]
        }else if(this.deltype==2){
          data.IdList = this.chooselist.map(v=>v.Id)
        }
        this.delShow = false
        let res = await liveRoomProductRepositorydelete(data)
        if(res.IsSuccess){
          this.$message.success('已删除')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private delrow(row){
      this.rowmsg = row
      this.delShow = true
      this.deltype = 1
    }
    private batchdel(){
      // this.batchShow = true
      // console.log(this.chooselist)
      if(!this.chooselist||!this.chooselist.length){
        this.$message.error('请选择要删除的商品')
        return
      }
      this.delShow = true
      this.deltype = 2
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Name:this.keywords,
          AuditStatus:2,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        let res=  await liveRoomProductRepositorylist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
  }
